import React from 'react';
import { useSelector } from 'react-redux';
import Card from '~/components/shared/Card/Card';
import CardHeader from '~/components/shared/CardHeader/CardHeader';
import CardSection from '~/components/shared/CardSection/CardSection';
import { SvgSrc } from '~/components/shared/Icon/Icon';
import { StartupCost } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import { Offer } from '~/Interfaces';

interface Props {
  data: Offer;
}

const LoanTermsCard: React.FC<Props> = ({ data }) => {
  const translate = useTranslate();
  const { market } = useSelector((state: RootState) => state.intl);

  const addMonthAfterBindingTerm = (bindingTerm: number) =>
    bindingTerm === 1
      ? `${bindingTerm} ${translate('Month')}`
      : `${bindingTerm} ${translate('Months')}`;

  return (
    <Card noPadding dataTestId="loan-offer-terms-card">
      <CardHeader value={translate('LoanTermsCard.Title') as string} />
      <CardSection
        title={translate('LoanTermsCard.StartupFee') as string}
        value={StartupCost[market]}
        iconSrc={SvgSrc.CreativeCommonNc}
        borderTop
      />
      <CardSection
        title={translate('LoanTermsCard.BindingPeriod') as string}
        value={
          data.bindingTerm > 0
            ? addMonthAfterBindingTerm(data.bindingTerm)
            : (translate('LoanTermsCard.BindingPeriodValue') as string)
        }
        iconSrc={SvgSrc.UnlockAlt}
        borderTop
      />
      <CardSection
        title={translate('LoanTermsCard.PossibleLoanIncrease') as string}
        value={translate('LoanTermsCard.PossibleLoanIncreaseValue') as string}
        iconSrc={SvgSrc.ChartLine}
        borderTop
      />
    </Card>
  );
};

export default LoanTermsCard;
